import { z } from "zod";

export const healthConditionsSchema = z.object({
  healthConditions: z
    .array(z.string())
    .min(1, "Please, select at least 1 condition.")
    .max(4, "It is not possible to select more than 4 conditions."),
});
